/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventId: NonNullable<unknown> }} Commons_Error_ReferenceInputs */

const de_commons_error_reference = /** @type {(inputs: Commons_Error_ReferenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehlercode: ${i?.eventId}`)
};

/** @type {(inputs: Commons_Error_ReferenceInputs) => LocalizedString} */
const en_commons_error_reference = de_commons_error_reference;

/**

* @param {Commons_Error_ReferenceInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_reference = /** @type {((inputs: Commons_Error_ReferenceInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_ReferenceInputs, { locale?: "de" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_reference(inputs)
	return en_commons_error_reference(inputs)
});